import { Outlet, useRouterState } from "@tanstack/react-router";

import { ErrorBoundary } from "@/components/ErrorBoundary";
import { SiteFooter } from "@/components/SiteFooter";

/** Root layout: a single error boundary around the whole route tree (reset on
 * navigation) plus the global site footer, shown on every page as in the old
 * app. */
export function RootLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return (
    <ErrorBoundary resetKey={pathname}>
      <div className="flex min-h-screen flex-col">
        <div className="flex-1">
          <Outlet />
        </div>
        <SiteFooter />
      </div>
    </ErrorBoundary>
  );
}
